import DeltaTable from "Components/Common/DeltaTable"
import React, { Dispatch, SetStateAction, useCallback, useContext, useEffect, useState } from "react"
import { useHistory } from "react-router-dom"
import { TChildSelected } from "types/Pages/ProductDelta"
import { TTableHeader } from "types/Components/Common/Table/Table"
import Utils from "Common/Utils"
import { listChildProductsByParentId } from "api/Products"
import { ProductsContext } from "Components/GMS/Products/ProductsContext"

interface MyProps {
    item: any,
    columns: TTableHeader[] | null
    handleSelectAll: (e: React.ChangeEvent<HTMLInputElement>, rows?: any) => void
    isSelectedCondition: (row: any) => 0 | 1 | -1
    selectedAllCondition: (row: any) => 0 | 1 | -1
    handleSelect: (e: React.ChangeEvent<HTMLInputElement>, deltaItem: any) => void
    setChildSelected: Dispatch<SetStateAction<TChildSelected>>
    setMoveToParentModal: Dispatch<SetStateAction<boolean>>
    setRemoveChildModal: Dispatch<SetStateAction<boolean>>
}

const AccordionTable = ({
    item,
    columns,
    handleSelectAll,
    isSelectedCondition,
    selectedAllCondition,
    handleSelect,
    setChildSelected,
    setMoveToParentModal,
    setRemoveChildModal
} : MyProps) => {
    const history = useHistory()
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(true)
    const {removeChildModal} = useContext(ProductsContext)

    const childDropdownOptions = (item: any) => {
        return [
            {
                label: 'Preview',
                callbackFunction: () => {
                    history.push(`/gms/product/details/${item.id}`)
                }
            },
            {
                label: 'Move to parent',
                callbackFunction: () => {
                    setChildSelected([item])
                    setMoveToParentModal(true)
                }
            },
            {
                label: 'Remove child',
                callbackFunction: () => {
                    setChildSelected([item])
                    setRemoveChildModal(true)
                }
            },
        ]
    }

    const fetchChildProducts = useCallback(async (item: any) => {
        setLoading(true)
        const {data} = await listChildProductsByParentId(item.id)
        
        await setData(data)
        setLoading(false)
    }, [])

    useEffect(() => {
        if(removeChildModal) return 
        item && fetchChildProducts(item)
    }, [removeChildModal])

    return <DeltaTable 
        data={data}
        dataLoading={loading}
        columns={columns}
        handleSelectAll ={handleSelectAll}
        isSelectedCondition ={isSelectedCondition}
        selectedAllCondition ={selectedAllCondition}
        handleSelect ={handleSelect}
        dataCallback ={(item: any) => Utils.getDeltaValue(item)}
        // fetchData ={() => fetchChildProducts(item)}
        options = {{
            dropDownCallback: childDropdownOptions,
            disableSort: true,
            disableHeaderControls: true,
            disableheaderSelectAll: true,
            headerClassName: "!tw-py-1 !tw-bg-[#eeeff1] tw-text-xs !tw-text-[#6B778C]",
            headerStickyToClassName: "!tw-to-[#eeeff1]",
            selectable: true,
            firstColPaddingLeft: 30,
            image: (item: any) => item.image && JSON.parse(item.image)?.[0].JPEG_IMAGES?.default_image,
            dataLoadingComponent: (tableWidth: string|number) => <tr>
                <td colSpan={columns?.length}>
                        <div style={{width: tableWidth}} className={`tw-text-xs tw-p-2 tw-text-center tw-sticky tw-left-0 tw-w-full tw-animate-pulse`}>
                        Loading...
                        </div>
                    </td>
                </tr>
        }}/>
}

export default React.memo(AccordionTable)